import PortalLayout from "layouts/PortalLayout";

export default function InstructorLayout() {
  return (
    <PortalLayout
      authGuard="instructor"
      sidebarLayout="/instructor"
      fallbackTitleAr="بوابة المحاضر"
      fallbackTitleEn="Instructor Dashboard"
    />
  );
}
